<template>
  <div class="invoice_msg">
    <div class="invoice_nav">
      <navbar
        title="开票资料"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <p class="tip">请按以下信息开具发票 <span>（长按可复制）</span></p>
      <van-row class="info">
        <van-col span="24">
          公司名称
          <span
            ref="copytxt1"
            @touchstart="gtouchstart(1)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend()"
            >{{ invoiceMsg.corporate_name }}</span
          >
        </van-col>
        <van-col span="24">
          纳税人识别号
          <span
            ref="copytxt2"
            @touchstart="gtouchstart(2)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend()"
            >{{ invoiceMsg.tax_number }}</span
          >
        </van-col>
        <van-col span="24">
          地址
          <span
            ref="copytxt3"
            @touchstart="gtouchstart(3)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend()"
            >{{ invoiceMsg.address }}</span
          >
        </van-col>
        <van-col span="24">
          电话
          <span
            ref="copytxt4"
            @touchstart="gtouchstart(4)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend()"
            >{{ invoiceMsg.tel }}</span
          >
        </van-col>
        <van-col span="24">
          账户
          <span
            ref="copytxt5"
            @touchstart="gtouchstart(5)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend()"
            >{{ invoiceMsg.account_number }}</span
          >
        </van-col>
        <van-col span="24">
          开户行
          <span
            ref="copytxt6"
            @touchstart="gtouchstart(6)"
            @touchmove="gtouchmove()"
            @touchend="gtouchend()"
            >{{ invoiceMsg.opening_bank }}</span
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
export default {
  components: {
    navbar,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      invoiceMsg: {},
      timeOutEvent: 0,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api
        .post("/member-relation/member/three/year/supplier/invoice-info", {
          tax_type: this.$route.query.tax_type,
        })
        .then((res) => {
          this.invoiceMsg = res;
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    copyCode(index) {
      const rechage_range = document.createRange();
      rechage_range.selectNode(this.$refs["copytxt" + index]);
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    //开始按
    gtouchstart(index) {
      document.oncontextmenu = function (e) {
        e.preventDefault();
      };
      this.timeOutEvent = setTimeout(() => {
        this.copyCode(index);
      }, 1000);
      return false;
    },
    gtouchend() {
      clearTimeout(this.timeOutEvent);
    },
    gtouchmove() {
      clearTimeout(this.timeOutEvent);
    },
  },
};
</script>
<style lang="less" scoped>
.invoice_msg {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding: 9.2rem 1.6rem 0;
    box-sizing: border-box;
    height: 100%;

    .tip {
      color: #333;
      font-size: 1.6rem;
      font-weight: 700;
      height: 5.4rem;
      line-height: 5.4rem;

      span {
        color: #f42337;
        font-size: 1.3rem;
      }
    }

    .info {
      background: #fff;
      border-radius: 0.8rem;
      padding: 1rem 2rem;

      .van-col {
        min-height: 4rem;
        line-height: 2rem;
        padding: 1rem 0;
        color: #999;
        font-size: 1.4rem;

        span {
          float: right;
          color: #333;
          width: calc(100% - 100px);
          text-align: right;
          word-break: break-all;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style>




